import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  header: {
    color: '#333333',
    fontWeight: 800,
    fontSize: '2rem',
    display: 'inline-block',
    paddingTop: '5px',
    '&::before': {
      content: '""',
      display: 'block',
      width: '50px',
      height: '3px',
      position: 'relative',
      top: '-5px',
      backgroundColor: '#3871c2'
    }
  },
  headerH3: {
    fontSize: '1.5rem',
    '&::before': {
      width: '40px',
    }
  },
  headerH4: {
    fontSize: '1.17rem',
    '&::before': {
      width: '30px',
    }
  },
  headerLight: {
    color: 'white',
    '&::before': {
      backgroundColor: '#50ade5',
    }
  },
  [theme.breakpoints.down('sm')]: {
    header: {
      fontSize: '1.7rem'
    },
    headerH3: {
      fontSize: '1.3rem'
    },
    headerH4: {
      fontSize: '1.1rem'
    },
  },
}))

const SectionHeader = ({ children, className, white, h3, h4, tag }) => {
  const classes = useStyles()
  const component = tag ? tag : (h3 ? 'h3' : (h4 ? 'h4' : 'h2'))

  return (
    <Typography className={`${className} ${classes.header} ${classes.headerLine} ${h3 ? classes.headerH3 : (h4 ? classes.headerH4 : '')} ${white ? classes.headerLight : ''}`} component={component}>
      {children}
    </Typography>
  )
}

export { SectionHeader }
